// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__oC643","footerLeft":"footer_footerLeft__xd7ZN","footerRight":"footer_footerRight__Lp37v"};